import React from "react";

export const Panel = ({ title, subtitle, right, children, className = "", testId }) => (
    <div data-testid={testId} className={`pbi-card ${className}`}>
        {(title || right) && (
            <div className="flex items-center justify-between px-4 py-3 border-b border-panel">
                <div>
                    {title && <div className="text-sm font-semibold text-[var(--text-primary)] tracking-tight">{title}</div>}
                    {subtitle && <div className="text-[11px] mt-0.5 text-[var(--text-secondary)]">{subtitle}</div>}
                </div>
                {right}
            </div>
        )}
        <div className="p-4">{children}</div>
    </div>
);

export default Panel;
